const API_COMMON_TEXT =
  "エラーが発生しました\nアプリを再起動するかサポートに\nお問い合わせください";

export const errors = {
  /* ----- アプリ側エラー ----- */
  APP_OTHER_ERROR: {
    code: "APP001",
    text: "エラーが発生しました\nアプリを再起動してください",
  },
  APP_CONNECTION_FAILED: {
    code: "APP002",
    text: "通信エラーが発生しました\n時間をおいて再度実行してください",
  },
  APP_ILLEGAL_OPERATION: {
    code: "APP003",
    text: "不正な操作が行われました\nトップページへ移動します",
  },
  GEO_PERMISSION_DENIED: {
    code: "GEO001",
    text: "位置情報の利用を許可してください",
  },
  GEO_POSITION_UNAVAILABLE: {
    code: "GEO002",
    text: "デバイスの位置が判定できません\n位置情報の取得に失敗しました",
  },
  GEO_TIMEOUT: {
    code: "GEO003",
    text: "タイムアウトしました\n位置情報の取得に失敗しました",
  },
  GEO_UNREGISTERED: {
    code: "GEO004",
    text: "利用者宅の緯度,経度情報が登録されていません\n位置情報の取得に失敗しました",
  },
  GEO_OTHER_ERROR: {
    code: "GEO005",
    text: "位置情報の取得に失敗しました",
  },

  /* ----- API側エラー ----- */
  // 共通
  COM_INVALID_ACCESSKEY: {
    code: "COM001",
    text: API_COMMON_TEXT,
  },
  COM_INVALID_TOKEN: {
    code: "COM002",
    text: API_COMMON_TEXT,
  },
  COM_INVALID_USER: {
    code: "COM003",
    text: API_COMMON_TEXT,
  },
  COM_INVALID_ACTION: {
    code: "COM004",
    text: API_COMMON_TEXT,
  },
  COM_OTHER_ERROR: {
    code: "COM999",
    text: API_COMMON_TEXT,
  },
  // スケジュールを取得する/schedule
  SCH_INVALID_PARAM: {
    code: "SCH001",
    text: API_COMMON_TEXT,
  },
  // サービスを取得する/service
  SRV_INVALID_PARAM: {
    code: "SRV001",
    text: API_COMMON_TEXT,
  },
  // サービスの特記・連絡事項を取得する/serviceNote
  SNT_INVALID_PARAM: {
    code: "SNT001",
    text: API_COMMON_TEXT,
  },
  // サービスを開始する/beginService
  BGS_INVALID_PARAM: {
    code: "BGS001",
    text: API_COMMON_TEXT,
  },
  // サービスを終了する/endService
  EDS_INVALID_PARAM: {
    code: "EDS001",
    text: API_COMMON_TEXT,
  },
  // 実施記録の項目を取得する/kirokuItem
  KIM_INVALID_PARAM: {
    code: "KIM001",
    text: API_COMMON_TEXT,
  },
  // 予定の実績状態を更新する/updKiroku
  UPK_INVALID_PARAM: {
    code: "UPK001",
    text: API_COMMON_TEXT,
  },
  UPK_INVALID_INPUT: {
    code: "UPK002",
    text: "使用禁止の文字を入力しています。他の文字に置き換えるか削除してください。",
  },
  // パスワードを変更する/changePassword
  CPW_INVALID_PARAM: {
    code: "CPW001",
    text: API_COMMON_TEXT,
  },
  CPW_INVALID_OLDPASS: {
    code: "CPW002",
    text: "エラーが発生しました\n現在のパスワードが違います",
  },
  // パスワードをリセットする/forgotPassword
  FPW_INVALID_PARAM: {
    code: "FPW001",
    text: API_COMMON_TEXT,
  },
  FPW_MAIL_NOTFOUND: {
    code: "FPW002",
    text: "エラーが発生しました\nメールアドレスが見つかりません",
  },
  // メールアドレスを変更する/changeEmail
  CML_INVALID_PARAM: {
    code: "CML001",
    text: API_COMMON_TEXT,
  },
  CML_MAIL_NOTFOUND: {
    code: "CML002",
    text: "エラーが発生しました\nメールアドレスが見つかりません",
  },
};

export const getApiError = (apiErr) => {
  if (apiErr.code === errors.UPK_INVALID_INPUT.code) {
    return getForbiddenWordError(apiErr);
  }

  for (const err in errors) {
    if (apiErr.code === errors[err].code) {
      return { code: apiErr.code, text: errors[err].text };
    }
  }

  return errors.COM_OTHER_ERROR;
};

const getForbiddenWordError = (apiErr) => {
  let word = "";
  Object.keys(apiErr.data).forEach(function (lKey) {
    Object.keys(this[lKey].child).forEach(function (mKey) {
      if ("child" in this[mKey]) {
        Object.keys(this[mKey].child).forEach(function (sKey) {
          word += this[sKey].error;
        }, this[mKey].child);
      } else {
        word += this[mKey].error;
      }
    }, this[lKey].child);
  }, apiErr.data);

  return {
    code: apiErr.code,
    text: `${errors.UPK_INVALID_INPUT.text}\n使用禁止文字「${word}」`,
  };
};

export const getGeoError = (geoErrcode) => {
  switch (geoErrcode) {
    case 1:
      return errors.GEO_PERMISSION_DENIED;
    case 2:
      return errors.GEO_POSITION_UNAVAILABLE;
    case 3:
      return errors.GEO_TIMEOUT;
    default:
      return errors.GEO_OTHER_ERROR;
  }
};
